import * as React from "react";
import { useSelector } from "react-redux";

import { Loader } from "semantic-ui-react";

import { QuestionnaireConfig } from "../../questionnaireConfig/models";
import { selectQuestionnaireAsQuestionnaireConfigFactory } from "../../questionnaireConfig/selectors";
import { QuestionnairesState } from "../../model";
import { CASE_ID, CUSTOMER_ID } from "../../routerParams";

import { REFERRAL_QUESTIONNAIRE_KEY, ReferralForm } from "./ReferralForm";

import { Location } from "redux-little-router";

interface Props {
    api?: string;
    documentBaseApi?: string;
}

export const ReadonlyCustomReferralForm: React.FunctionComponent<Props> = (props: Props) => {

    const questionnaireConfig: QuestionnaireConfig = useSelector((state: { questionnaires: QuestionnairesState }) =>
        selectQuestionnaireAsQuestionnaireConfigFactory(REFERRAL_QUESTIONNAIRE_KEY)(state));
    const customerId = useSelector((state: { router: Location }) => state.router.params[CUSTOMER_ID]);
    const ohCaseId = useSelector((state: { router: Location }) => state.router.params[CASE_ID]);

    const api = props.api ?? `/api/case/customer/${customerId}/matchedReferral/${ohCaseId}`;
    const documentBaseApi = props.documentBaseApi ?? `/api/referral/customer/${customerId}`;

    if (questionnaireConfig) {
        return <ReferralForm readonly={true} questionnaireConfig={questionnaireConfig} api={api} documentBaseApi={documentBaseApi} />;
    }

    return <Loader active />;
};
